import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';

import type { PriorityScale } from '../lib/priority';

export function usePriorityLabels(): Record<PriorityScale, string> {
  const { t } = useLingui();

  return useMemo(
    () => ({
      1: t`Low`,
      2: t`Reduced`,
      3: t`Normal`,
      4: t`Increased`,
      5: t`High`,
    }),
    [t],
  );
}
